import { type Booking } from '@vakantiesnl/types';

export const numberOfFlightFilters = (filters: Booking.FlightFilters): number =>
	Object.entries(filters).reduce((acc: number, filter): number => {
		if (filter[1] === true || filter[1] instanceof Object) {
			return acc + 1;
		} else {
			return acc;
		}
	}, 0);
